<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// Emits
const emit = defineEmits(['open-search'])

const router = useRouter()

const username = localStorage.getItem('username')

const goToProfile = () => {
  if (username) {
    router.push(`/perfil/${username}`)
  } else {
    router.push('/login')
  }
}

const openSearch = () => {
  emit('open-search')
}
</script>

<template>
  <v-bottom-navigation
    grow
    app
    class="background-color"
    height="65"
  >
    <v-btn value="games" :to="{ name: 'GamesPageBeta' }" class="nav-btn">
      <v-icon class="logo-color nav-icon">mdi-soccer</v-icon>
      <span class="logo-color nav-text">Jogos</span>
    </v-btn>

    <v-btn value="search" @click="openSearch" class="nav-btn">
      <v-icon class="logo-color nav-icon">mdi-magnify</v-icon>
      <span class="logo-color nav-text">Buscar</span>
    </v-btn>

    <v-btn value="feed" :to="{ name: 'Feed' }" class="nav-btn">
      <v-icon class="logo-color nav-icon">mdi-comment-multiple</v-icon>
      <span class="logo-color nav-text">Seguindo</span>
    </v-btn>

    <v-btn value="profile" @click="goToProfile" class="nav-btn">
      <v-icon class="logo-color nav-icon">mdi-account</v-icon>
      <span class="logo-color nav-text">Perfil</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<style scoped>
.saffron-color {
  color: var(--butter-yellow) !important;
}

.background-color {
  background-color: var(--seaweed-green) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-color {
  color: #FEF3C7E6;
}

.nav-btn {
  flex-direction: column;
  padding: 8px 4px;
  min-width: 0;
  height: 100% !important;
}

.nav-icon {
  font-size: 20px !important;
  margin-bottom: 4px;
}

.nav-text {
  font-size: 11px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  line-height: 1;
}

/* Active state */
.nav-btn.v-btn--active {
  background-color: rgba(254, 243, 199, 0.1);
}

.nav-btn.v-btn--active .logo-color {
  color: #FEF3C7 !important;
  font-weight: 600;
}

/* Hover effect */
.nav-btn:hover {
  background-color: rgba(254, 243, 199, 0.05);
}
</style>